import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link, useNavigate, useParams } from 'react-router-dom';
import '../Assets/CSS/companyDetail.css';
import companylogo from '../Assets/Images/companylogo.jpeg';
import ContactUs from '../sections/home/Contactus';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import { Button } from 'react-bootstrap';
import { getCookie } from '../components/auth/login/GetCookie';

const CompanyDetailpage = () => {
    const navigate = useNavigate();

    const { id } = useParams(); // Get sellerId from URL
    const [activeTab, setActiveTab] = useState('All');
    const [categories, setCategories] = useState(['All']); // Categories will be populated dynamically
    const [productList, setProductList] = useState([]); // Product list state
    const [filteredProducts, setFilteredProducts] = useState([]); // Filtered products based on category
    const [error, setError] = useState(null); // Error state
    const [loading, setLoading] = useState(false); // Loading state
    const [companyInfo, setCompanyInfo] = useState({
    });
    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);
            try {
                // const token = localStorage.getItem("token");
                const token = getCookie("token");
                // await new Promise(res => setTimeout(res, 2000));
                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/v1/user/products/seller`,
                    {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                      },
                      params: { sellerId: id }, // Pass params properly
                    }
                  );

                const products = response.data.content || [];
                setProductList(products); // Set the full product list
                setFilteredProducts(products); // Initialize filtered products

                // Dynamically populate categories based on products
                const uniqueCategories = [
                    'All',
                    ...new Set(products.map((product) => product.productCategoryNames)),
                ];
                setCategories(uniqueCategories);
            } catch (error) {
                console.error("Error fetching products:", error);
                setError("Failed to fetch products. Please try again later.");
               
            }
            finally{
                setLoading(false);
            }
        };

        const fetchCompanyDetail = async () => {
            setLoading(true);
            try {
                // const token = localStorage.getItem("token");
                const token = getCookie("token");
await new Promise(res => setTimeout(res, 2000));
                const response = await axios.get(
                  `${process.env.REACT_APP_BACKEND_URL}/api/v1/company-profile`,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`,
                    },
                    params: { companyOwnerId: id }, // Properly passing params
                  }
                );
            
               
                setCompanyInfo(response.data);
            } catch (error) {
                console.error("Error fetching products:", error);
                setError("Failed to fetch products. Please try again later.");
               
            }
            finally{
                setLoading(false);
            }
        };

        fetchCompanyDetail();
        fetchProducts();
    }, [id]); // Re-run if sellerId changes

    // Handle tab selection and product filtering
    const handleTabClick = (category) => {
        setActiveTab(category);
        if (category === 'All') {
            setFilteredProducts(productList);
        } else {
            setFilteredProducts(productList.filter((product) => product.productCategoryNames === category));
        }
    };


    const ProductCardSkeleton = () => (
        <div className="col d-flex">
            <div className="card h-100 shadow-sm d-flex flex-column  border p-3">
                <Skeleton height={200} width={200} className="mb-3 rounded-3" />
                <Skeleton height={24} width="75%" className="mb-2" />
                <Skeleton height={20} width="50%" className="mb-2" />
                <Skeleton height={20}  width="95%"/>
                <Skeleton height={20}  width="95%"/>
            </div>
        </div>
    );

    
    
    return (
        <div>
            <div className="container-fluid mt-3">
                {/* Banner Section */}
                <div className="row">
                    <div className="bannerimgcompany" 
                     style={{
                            backgroundImage: `url(${companyInfo?.companyHeaderImageUrl})`,
                            backgroundSize: "cover", // Ensures the image covers the di v properly
                            backgroundPosition: "center", // Centers the image
                        }}
                        >
                        <div className="row ">
                            <div className="col-10">
                                <div className="row text-left">
                                    <h1 className="blog-heading mt-3 pt-3">
                                        
                                        <Link to="/" className="text-white text-decoration-none" >
                                            <Icon icon="iconamoon:home-thin" className="fs-5 me-1" />
                                        </Link>
                                        <Icon icon="weui:arrow-outlined" className="fs-5 ms-1 me-1" />
                                        {/* <Link to="/" className="text-white text-decoration-none"> */}
                                            <span onClick={ () => {navigate("/companylist", { state: { selectedCountryLabel: filteredProducts[0]?.productCountry } })}} 
                                                style={{ cursor: "pointer" }}
                                                >
                                               {loading ? <Skeleton width={100} /> : filteredProducts[0]?.productCountry}
                                            </span>
                                        {/* </Link> */}
                                        <Icon icon="weui:arrow-outlined" className="fs-5 ms-1 me-1" />
                                        {loading ? <Skeleton width={150} /> : filteredProducts[0]?.sellerName}
                                    </h1>
                                </div>
                                <h2 className="Event-headingtwo">{loading ? <Skeleton width={200} /> : filteredProducts[0]?.sellerName}</h2>
                                <div className="row ms-3">
                                    <div className="col-lg-3 col-md-4 col-sm-12 d-flex justify-content-between align-items-center">
                                        <p className="eventer-name mb-0 text-start">{loading ? <Skeleton width={100} /> : companyInfo?.companyEstablishYear}</p>
                                        <p className="event-Detail-date mb-0 text-end"> {loading ? <Skeleton width={120} /> : companyInfo?.companyLocation}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Ribbon Section */}
                            <div className="col-2">
                                <div className="ribbon-container text-center">
                                    <div className="ribbon-top d-flex justify-content-center align-items-center">
                                        <div className="ribbon-left"></div>
                                        <div className="ribbon-middle"></div>
                                        <div className="ribbon-right"></div>
                                    </div>
                                    <div className="ribbon-box">
                                        {/* <div className="star-box position-relative">
                                            <span className="star star-top-left">★</span>
                                            <span className="star star-left-middle">★</span>
                                            <span className="star star-right-middle">★</span>
                                            <span className="star star-top-right">★</span>
                                            <span className="star star-bottom-left">★</span>
                                            <span className="star star-bottom-right">★</span>
                                        </div> */}
                                        <div className="content-box">
                                        {loading ? <Skeleton height={89} width={80} /> : 
                                        <img src={companyInfo?.companyLogoImagerUrl} alt="companylogo" 
                                        className="company-logo" />}
                                          
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Company Profile Section */}
                <div className="p-5">
                    <div className="">
                        <div className="">
                            <div className="company-profile">
                                <div className="company-profile-box">
                                    <h4 className="pt-1 ps-2">Profile:</h4>
                                    <p className="company-para p-2">  
                                    {loading ? <Skeleton count={3} /> : companyInfo?.companyProfileDescription}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Product Categories */}
                    <h4 className="mt-5">Products:</h4>
                    {error && <p className="text-danger">{error}</p>}

                        <>
                            <div className="row mt-2">
                                <div className="product-tabs-container">
                                    <div className="d-flex product-tabs flex-nowrap">
                                        {categories.map((category, idx) => (
                                            <div className="product-tab" key={idx}>
                                                <button
                                                    onClick={() => handleTabClick(category)}
                                                    className={`pro-tab-btn ${activeTab === category ? 'active' : ''}`}
                                                >
                                                    {category === 'All' ? `All (${productList.length})` : category}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Product List */}
                            
<div className="container mt-4">
    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4"> {/* ✅ Ensures equal spacing */}
    {loading
                                ? Array.from({ length: 8 }).map((_, index) => (
                                    <ProductCardSkeleton key={index} />
                                ))
                                :
        filteredProducts.map((product, _index) => (
            <div className="col d-flex"> {/* ✅ Ensures equal spacing & alignment */}
                <Link
                    to={`/productdetail/${product.productId}`} // Dynamic link with productId
                    className="text-decoration-none text-dark w-100" // ✅ Ensures full width
                >
                    <div className="card Product-card h-100 shadow-sm d-flex flex-column"> {/* ✅ Uniform height */}
                        <img
                            src={product.productImageUrls[0] || "No image "} // ✅ Fallback image
                            className="card-img-top product-card-img rounded-3"
                            alt={product.productName ||'No image'}
                            style={{ height: "200px", objectFit: "cover" }} // ✅ Uniform image size
                        />
                        <div className="card-body d-flex flex-column justify-content-between"> {/* ✅ Distributes content properly */}
                            <h5 className="card-title mt-2 product-text">{product.productName}</h5>
                            <h6 className="mb-2 mt-2 product-manuf">
                                {product.generalAttributes.manufacturer || "Unknown Manufacturer"}
                            </h6>
                            <p className="product-descriptn text-muted">
                                {product.generalAttributes.description || "No description available."}
                            </p>
                        </div>
                    </div>
                </Link>
            </div>
        ))}
    </div>
</div>





                        </>
                
                </div>
            </div>
            <ContactUs />
        </div>
    );
};

export default CompanyDetailpage;
